import { render, staticRenderFns } from "./slideMenu.vue?vue&type=template&id=7937cdcd&scoped=true"
import script from "./slideMenu.vue?vue&type=script&lang=js"
export * from "./slideMenu.vue?vue&type=script&lang=js"
import style0 from "./aside.scss?vue&type=style&index=0&id=7937cdcd&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7937cdcd",
  null
  
)

export default component.exports